export default __webpack_public_path__ + "static/media/LF-3Closed.57dba0f2.jpg";